function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }

function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }

function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { clocksNow, computeRawError, combine, createContextManager, ErrorSource, monitored, sanitize, createHandlingStack, buildTag, sanitizeTag } from '@datadog/browser-core';
import { isAuthorized, StatusType } from './logger/isAuthorized';
import { createErrorFieldFromRawError } from './createErrorFieldFromRawError';
export var HandlerType = {
  console: 'console',
  http: 'http',
  silent: 'silent'
};
export var STATUSES = Object.keys(StatusType); // note: it is safe to merge declarations as long as the methods are actually defined on the prototype
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging, no-restricted-syntax

export var Logger = /*#__PURE__*/function () {
  function Logger(handleLogStrategy, name) {
    var handlerType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : HandlerType.http;
    var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : StatusType.debug;
    var loggerContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    _classCallCheck(this, Logger);

    this.handleLogStrategy = handleLogStrategy;
    this.handlerType = handlerType;
    this.level = level;
    this.contextManager = createContextManager('logger');
    this.tags = [];
    this.contextManager.setContext(loggerContext);

    if (name) {
      this.contextManager.setContextProperty('logger', {
        name: name
      });
    }
  }

  _createClass(Logger, [{
    key: "logImplementation",
    value: function logImplementation(message, messageContext) {
      var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : StatusType.info;
      var error = arguments.length > 3 ? arguments[3] : undefined;
      var handlingStack = arguments.length > 4 ? arguments[4] : undefined;
      var sanitizedMessageContext = sanitize(messageContext);
      var context;

      if (error !== undefined && error !== null) {
        var rawError = computeRawError({
          originalError: error,
          nonErrorPrefix: "Provided"
          /* NonErrorPrefix.PROVIDED */
          ,
          source: ErrorSource.LOGGER,
          handling: "handled"
          /* ErrorHandling.HANDLED */
          ,
          startClocks: clocksNow()
        });
        context = combine({
          error: createErrorFieldFromRawError(rawError, {
            includeMessage: true
          })
        }, rawError.context, sanitizedMessageContext);
      } else {
        context = sanitizedMessageContext;
      }

      this.handleLogStrategy({
        message: sanitize(message),
        context: context,
        status: status
      }, this, handlingStack);
    }
  }, {
    key: "log",
    value: function log(message, messageContext) {
      var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : StatusType.info;
      var error = arguments.length > 3 ? arguments[3] : undefined;
      var handlingStack;

      if (isAuthorized(status, HandlerType.http, this)) {
        handlingStack = createHandlingStack('log');
      }

      this.logImplementation(message, messageContext, status, error, handlingStack);
    }
  }, {
    key: "setContext",
    value: function setContext(context) {
      this.contextManager.setContext(context);
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this.contextManager.getContext();
    }
  }, {
    key: "setContextProperty",
    value: function setContextProperty(key, value) {
      this.contextManager.setContextProperty(key, value);
    }
  }, {
    key: "removeContextProperty",
    value: function removeContextProperty(key) {
      this.contextManager.removeContextProperty(key);
    }
  }, {
    key: "clearContext",
    value: function clearContext() {
      this.contextManager.clearContext();
    }
  }, {
    key: "addTag",
    value: function addTag(key, value) {
      this.tags.push(buildTag(key, value));
    }
  }, {
    key: "removeTagsWithKey",
    value: function removeTagsWithKey(key) {
      var sanitizedKey = sanitizeTag(key);
      this.tags = this.tags.filter(function (tag) {
        return tag !== sanitizedKey && !tag.startsWith("".concat(sanitizedKey, ":"));
      });
    }
  }, {
    key: "getTags",
    value: function getTags() {
      return this.tags.slice();
    }
  }, {
    key: "setHandler",
    value: function setHandler(handler) {
      this.handlerType = handler;
    }
  }, {
    key: "getHandler",
    value: function getHandler() {
      return this.handlerType;
    }
  }, {
    key: "setLevel",
    value: function setLevel(level) {
      this.level = level;
    }
  }, {
    key: "getLevel",
    value: function getLevel() {
      return this.level;
    }
  }]);

  return Logger;
}();

__decorate([monitored], Logger.prototype, "logImplementation", null);
/* eslint-disable local-rules/disallow-side-effects */


Logger.prototype.ok = createLoggerMethod(StatusType.ok);
Logger.prototype.debug = createLoggerMethod(StatusType.debug);
Logger.prototype.info = createLoggerMethod(StatusType.info);
Logger.prototype.notice = createLoggerMethod(StatusType.notice);
Logger.prototype.warn = createLoggerMethod(StatusType.warn);
Logger.prototype.error = createLoggerMethod(StatusType.error);
Logger.prototype.critical = createLoggerMethod(StatusType.critical);
Logger.prototype.alert = createLoggerMethod(StatusType.alert);
Logger.prototype.emerg = createLoggerMethod(StatusType.emerg);

function createLoggerMethod(status) {
  return function (message, messageContext, error) {
    var handlingStack;

    if (isAuthorized(status, HandlerType.http, this)) {
      handlingStack = createHandlingStack('log');
    }

    this.logImplementation(message, messageContext, status, error, handlingStack);
  };
}